import { WebsiteBrandingPage } from './index'

import { RouteFactory } from './../../shared/router/Route.factory'
import { RequiresAuthGuard, BlockedWhiteLabelGuard } from './../../shared/router/guards'

export default [
  RouteFactory.create(
    WebsiteBrandingPage,
    '/website-branding',
    [new RequiresAuthGuard(true), new BlockedWhiteLabelGuard(true)],
    {
      name: 'Website Branding',
    }
  ),
]
